// Mock data for ACT of Gilroy church website

export const siteData = {
  brand: {
    name: 'APOSTOLIC CHRIST TABERNACLE',
    short: 'ACT',
  },
  nav: [
    { label: 'Staff', href: '#staff' },
    { label: 'About', href: '#about' },
    { label: 'Contact', href: '#contact' },
  ],
  hero: {
    title: 'Welcome to ACT of Gilroy',
    description:
      "Experience heartfelt worship, biblical preaching, and the life-changing power of God's presence. At Apostolic Christ Tabernacle ( ACT ), we're more than a church\u2014we're a family committed to growing in faith, loving our community, and sharing the hope found in Jesus Christ. No matter where you are on your journey, there's a place for you here.",
    backgroundImage:
      'https://customer-assets-lxgj4vgw.emergentagent.net/job_laughing-proskuriakova-15/artifacts/3hm0dlnf_G08A0052.webp',
  },
  services: [
    {
      id: 1,
      title: 'SUNDAY WORSHIP',
      day: 'Sunday',
      time: '10:00 AM',
      image:
        'https://customer-assets-lxgj4vgw.emergentagent.net/job_laughing-proskuriakova-15/artifacts/lr7fr939_Sunday%20Block.png',
    },
    {
      id: 2,
      title: 'MONDAY NIGHT PRAYER',
      day: 'Monday',
      time: '6:30PM - 7:30PM',
      image:
        'https://customer-assets-lxgj4vgw.emergentagent.net/job_laughing-proskuriakova-15/artifacts/0gjmnruy_MNP%20Block.png',
    },
    {
      id: 3,
      title: 'MDWK SERVICE',
      day: 'Wednesday',
      time: '7:00PM',
      image:
        'https://customer-assets-lxgj4vgw.emergentagent.net/job_laughing-proskuriakova-15/artifacts/nnlnpm3w_MDWK%20BLOCK.png',
    },
  ],
  address: '370 Tomkins Court Gilroy Ca, 95020',
  planVisit: {
    title: 'Plan a Visit',
    text: "We can't wait to meet you, click the button below to get connected with us!",
    cta: 'Plan a visit',
  },
  online: {
    title: 'Can\u2019t make it to the Campus?',
    text: 'Grab your family, and join us online!',
    cta: 'ACT Online',
    image:
      'https://customer-assets-lxgj4vgw.emergentagent.net/job_laughing-proskuriakova-15/artifacts/xxh0jrkn_IMG_1947%202.webp',
    youtubeChannelId: 'UC7lj9ts7CWq6PLhwRhRL_TA',
    youtubeEmbedUrl:
      'https://www.youtube.com/embed/videoseries?list=UU7lj9ts7CWq6PLhwRhRL_TA&rel=0&modestbranding=1',
  },
  gallery: [
    'https://customer-assets-lxgj4vgw.emergentagent.net/job_laughing-proskuriakova-15/artifacts/oldg8a1k_about%20us.webp',
    'https://customer-assets-lxgj4vgw.emergentagent.net/job_laughing-proskuriakova-15/artifacts/lkcr0g17_max.webp',
    'https://customer-assets-lxgj4vgw.emergentagent.net/job_laughing-proskuriakova-15/artifacts/2dsgpc6o_dave.webp',
    'https://customer-assets-lxgj4vgw.emergentagent.net/job_laughing-proskuriakova-15/artifacts/toqtfxtv_Matt%20and%20Issac.webp',
  ],
  footer: {
    tagline: 'A place for you to belong.',
    email: 'info@actgilroy.org',
    phone: '408-337-1477',
    facebook: 'https://www.facebook.com/actmorganhill',
    instagram: 'https://www.instagram.com/apostolicchristtabernacle/',
    youtube: 'https://www.youtube.com/@ACT_238',
    social: ['Instagram', 'Facebook', 'YouTube'],
  },
};
